import { isValidPermission, isAccountPermission } from './index.js';
import { masqAccess, MasqAccess } from './masq.js';
// This should be written with zero-trust by default. Start from no access and
// gradually check for higher permissions.
export function checkPermission(user, account, 
// TODO: Later this should be Record<number, RoleDefinition>, when we switch to
// fetching roles exclusively from the API - the number will be the role ID.
// Right now the string is the role name (because the hard coded UI roles don't have IDs).
roles, permission, workspaceId) {
    if (!isValidPermission(permission) || user == null || account == null) {
        return false;
    }
    // Masq access — checked before write_access so that masq ReadWrite
    // can grant edit permissions even on read-only accounts.
    if (account.is_masq) {
        const access = masqAccess(user.masq_permissions);
        // This block could be compressed, but since it's important, let's be explicit.
        if (access === MasqAccess.None) {
            return false;
        }
        else if (access === MasqAccess.Read && !permission.endsWith('view')) {
            return false;
        }
        else if (access === MasqAccess.Read) {
            return true;
        }
        else if (access === MasqAccess.ReadWrite) {
            return true;
        }
    }
    // Read-only accounts
    if (!account.write_access && !permission.endsWith('view')) {
        return false;
    }
    // Checks user account permissions
    if (user.account_permissions != null && isAccountPermission(permission)) {
        return user.account_permissions.includes(permission);
    }
    // Check if the user has the permission through their role
    if (user.workspace_roles != null && roles != null && workspaceId != null) {
        const maybeRoleIdForWorkspace = user.workspace_roles[workspaceId];
        const maybeRole = maybeRoleIdForWorkspace != null ? roles[maybeRoleIdForWorkspace.name] : null;
        if (maybeRole != null) {
            return maybeRole.workspacePermissions.has(permission);
        }
        return false;
    }
    return false;
}
//# sourceMappingURL=validation.js.map